export const fixError = (inputString: string) => {
    // Регулярное выражение для удаления текста, начиная с "Provided assetNumber" и до конца строки
    const regex = /Provided assetNumber.*$/;
    const result = inputString.replace(regex, '');

    return result;
};
